import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { GetCrossProjectTasks, resetProjectData, selectProject } from '../../redux/projectDataSlice';
import { ArrowLeft16Regular } from '@fluentui/react-icons';
import { resetQestionBankData } from '../../redux/questionBankSlice';
import { GetProjectUsers, resetTeamData } from '../../redux/teamSlice';
import { resetObservationData } from '../../redux/meetingSlice';
import { resetDataroomData } from '../../redux/dataroomSlice';
import { resetDocumentData } from '../../redux/documentsSlice';
import { resetNdaData } from '../../redux/ndaSlice';
import { resetTaskData } from '../../redux/taskSlice';
const CrossProjectTasks = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { crossProjectTasks, selectedProject } = useSelector(state => state?.projectData);
    const { user } = useSelector(state => state.user);
    const userType = user?.types;
    React.useEffect(() => {
        dispatch(GetCrossProjectTasks());
    }, [dispatch]);

    const formatDate = dateString => {
        if (!dateString) return '-- --';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            });
        } catch (error) {
            console.error('Error formatting date:', error);
            return '-- --';
        }
    };

    const getStatusDisplay = status => {
        const statusMap = {
            NOT_STARTED: 'Not Started',
            WORKING_ON_IT: 'Working On It',
            STUCK: 'Stuck',
            COMPLETED: 'Completed',
            CANCELLED: 'Cancelled',
        };
        return statusMap[status] || status;
    };

    const isOverdue = endDate => {
        if (!endDate) return false;
        try {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // Reset time to start of day for accurate comparison
            const dueDate = new Date(endDate);
            dueDate.setHours(0, 0, 0, 0);
            return today > dueDate;
        } catch (error) {
            console.error('Error checking overdue status:', error);
            return false;
        }
    };

    const handleRowClick = async id => {
        if (selectedProject) {
            dispatch(selectProject({ id: null }));
            // navigate('/project');
            dispatch(resetObservationData());
            dispatch(resetDataroomData());
            dispatch(resetDocumentData());
            dispatch(resetNdaData());
            dispatch(resetProjectData());
            dispatch(resetQestionBankData());
            dispatch(resetTaskData());
            dispatch(resetTeamData());
        }
        localStorage.setItem('project_id', id);
        dispatch(
            selectProject({
                id,
                callback: () => navigate('/tasks'),
                userType: userType,
            }),
        );
        dispatch(resetQestionBankData()); // Reset IRL AI responses when changing projects
        await dispatch(GetProjectUsers());
        // if(res?.type==='GET_PROJECT_USERS/fulfilled'){

        // }
    };

    const projects = crossProjectTasks?.data?.projects || [];
    const isLoading = crossProjectTasks?.loading;
    const error = crossProjectTasks?.error;

    return (
        <div className="container-fluid ps-5 pe-5 mt-4">
            <div
                className="mb-4 d-flex align-items-center gap-2"
                style={{ cursor: 'pointer', color: 'var(--Brand-Secondary)', fontSize: 14, fontWeight: 600 }}
                onClick={() => navigate(-1)}
                role="button">
                <ArrowLeft16Regular /> Back
            </div>
            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>Loading...</div>
            ) : error ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#B00020' }}>Error loading tasks. Please try again.</div>
            ) : projects.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>No key tasks found across projects.</div>
            ) : (
                <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 770 }}>
                    <thead>
                        <tr className="tableHeadRow" style={{ padding: '8px 22px 7px 16px', height: 32, color: 'white', fontSize: 12, fontWeight: 'bold' }}>
                            <td className="headerItem" style={{ backgroundColor: 'var(--Brand-Primary)', padding: 8 }}>
                                <b style={{ fontFamily: "'Open Sans Bold', sans-serif" }}>Project</b>
                            </td>
                            <td className="headerItem" style={{ backgroundColor: 'var(--Brand-Primary)', padding: 8 }}>
                                <b style={{ fontFamily: "'Open Sans Bold', sans-serif" }}>Company Name</b>
                            </td>
                            <td className="headerItem" style={{ backgroundColor: 'var(--Brand-Primary)', padding: 8 }}>
                                <b style={{ fontFamily: "'Open Sans Bold', sans-serif" }}>Status</b>
                            </td>
                            <td className="headerItem" style={{ backgroundColor: 'var(--Brand-Primary)', padding: 8 }}>
                                <b style={{ fontFamily: "'Open Sans Bold', sans-serif" }}>
                                    <div className="d-flex align-items-center gap-2">
                                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M5.6939 0.501691C6.02403 -0.167228 6.97789 -0.167232 7.30802 0.501691L8.82911 3.58374L12.2304 4.07797C12.9685 4.18524 13.2633 5.09241 12.7291 5.6131L10.268 8.01214L10.849 11.3996C10.9751 12.1349 10.2034 12.6955 9.54313 12.3484L6.50096 10.749L3.45879 12.3484C2.79853 12.6955 2.02684 12.1349 2.15294 11.3996L2.73394 8.01214L0.272773 5.6131C-0.261391 5.09242 0.0333649 4.18524 0.771565 4.07797L4.17281 3.58374L5.6939 0.501691Z"
                                                fill="#FFC107"
                                            />
                                        </svg>
                                        KeyTask
                                    </div>
                                </b>
                            </td>
                            <td className="headerItem" style={{ backgroundColor: 'var(--Brand-Primary)', padding: 8 }}>
                                <b style={{ fontFamily: "'Open Sans Bold', sans-serif" }}>Due by</b>
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        {projects.map(project => {
                            const task = project.task;
                            if (!task) return null;

                            return (
                                <tr
                                    onClick={() => handleRowClick(project.project_id)}
                                    role="button"
                                    key={project.project_id}
                                    style={{ height: 32, borderBottom: 'solid 1px rgba(130, 154, 177, 0.5)', fontSize: 12, color: '#1b2149' }}>
                                    <td style={{ padding: 8 }}>{project.project_name || '--'}</td>
                                    <td style={{ padding: 8 }}>{project.company_name || '--'}</td>
                                    <td style={{ padding: 8 }}>{getStatusDisplay(task.status)}</td>
                                    <td style={{ padding: 8 }}>{task.task || '--'}</td>
                                    <td style={{ padding: 8 }}>
                                        {task.deadline ? (
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                                {isOverdue(task.deadline) && (
                                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3ZM8 10C8.41421 10 8.75 10.3358 8.75 10.75C8.75 11.1642 8.41421 11.5 8 11.5C7.58579 11.5 7.25 11.1642 7.25 10.75C7.25 10.3358 7.58579 10 8 10ZM8 4.5C8.24546 4.5 8.44961 4.67688 8.49194 4.91012L8.5 5V8.5C8.5 8.77614 8.27614 9 8 9C7.75454 9 7.55039 8.82312 7.50806 8.58988L7.5 8.5V5C7.5 4.72386 7.72386 4.5 8 4.5Z"
                                                            fill="#B00020"
                                                        />
                                                    </svg>
                                                )}
                                                <span>{formatDate(task.deadline)}</span>
                                            </div>
                                        ) : (
                                            '-- --'
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default CrossProjectTasks;
